import { IListItem } from '@app-types/websocket/sharedinfo.types';

export function formatSharedNoteListForClipboard(title:string, listItems:IListItem[]):string {
  const lines:string[] = [];
  const cleanTitle = title.trim();

  if (cleanTitle.length > 0) {
    lines.push(cleanTitle);
  }

  listItems
    .filter((item) => item.deleted !== true)
    .forEach((item) => {
      const value = item.val.trim();
      if (value.length === 0) {
        return;
      }

      if (item.format === 2) {
        if (lines.length > 0) {
          lines.push('');
        }
        lines.push(value);
      } else if (item.format === 1) {
        lines.push(`• ${value}`);
      } else {
        lines.push(`• ${value}`);
      }
    });

  return lines.join('\n');
}

export function formatSharedNoteListHtmlForClipboard(title:string, listItems:IListItem[]):string {
  const html:string[] = [];
  const cleanTitle = title.trim();
  let listOpen = false;

  const closeList = () => {
    if (listOpen) {
      html.push('</ul>');
      listOpen = false;
    }
  };

  if (cleanTitle.length > 0) {
    html.push(`<h1>${escapeHtml(cleanTitle)}</h1>`);
  }

  listItems
    .filter((item) => item.deleted !== true)
    .forEach((item) => {
      const value = item.val.trim();
      if (value.length === 0) {
        return;
      }

      if (item.format === 2) {
        closeList();
        html.push(`<h2>${escapeHtml(value)}</h2>`);
        return;
      }

      if (!listOpen) {
        html.push('<ul>');
        listOpen = true;
      }

      html.push(`<li>${item.format === 1 ? `<s>${escapeHtml(value)}</s>` : escapeHtml(value)}</li>`);
    });

  closeList();

  return html.join('');
}

function escapeHtml(text:string):string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}



// WEBPACK FOOTER //
// ./src/components/sharednotes/sharedNoteClipboard.ts